import { AppointmentRule } from 'services/clients/terminal';

export interface AppointmentTerminalRuleDefinition {
  /** The text to print in the refresh row of the table */
  header: string;
  key: AppointmentRule;
  includeRefresh?: boolean;
}

export const APPOINTMENT_TERMINAL_RULES: Partial<
  Record<AppointmentRule, AppointmentTerminalRuleDefinition>
> = {
  [AppointmentRule.RegistrationRequired]: {
    header: 'Registration is required',
    key: AppointmentRule.RegistrationRequired,
  },
  [AppointmentRule.ConfirmationRequired]: {
    header: 'Confirm with SSL',
    key: AppointmentRule.ConfirmationRequired,
  },
  [AppointmentRule.AppointmentBeforeOne]: {
    header: 'Appointment required before 1pm',
    key: AppointmentRule.AppointmentBeforeOne,
  },
  [AppointmentRule.AppointmentRequired]: {
    header: 'Appointment required',
    key: AppointmentRule.AppointmentRequired,
    includeRefresh: true,
  },
  [AppointmentRule.PreArrivalRequired]: {
    header: 'Pre-arrival required',
    key: AppointmentRule.PreArrivalRequired,
  },
  [AppointmentRule.NoAppointmentRequired]: {
    header: 'No appointment required',
    key: AppointmentRule.NoAppointmentRequired,
  },
};
